import { render, staticRenderFns } from "./sp-organisations.vue?vue&type=template&id=66422e4f&"
import script from "./sp-organisations.vue?vue&type=script&lang=js&"
export * from "./sp-organisations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports